/**
 * Central Management > 객체 >
 *  APT >> APT 프로파일 store
 *
 * @since 2020-04-10
 * @author tams_dev2
 */

import {ObjectSecProfileApiPrefix as opApiPrefix} from '~/utils/restApi'

export const state = () => ({
  // REST API
  api: {
    url: `${opApiPrefix}/apt/profiles`,
    config: {
      loading: false,
      successAlert: false
    }
  },
  finalCommand: `${opApiPrefix}/apt-profiles`,
  // APT 프로파일 초기화 데이터
  clearDetailModel: {
    apt_prf_id: null,
    apt_prf_uname: '',
    apt_prf_desc: '',

    http_use: 0,
    http_cache: 1,
    http_action: 0,
    http_file_size: 1024,

    smtp_use: 0,
    smtp_cache: 1,
    smtp_action: 0,
    smtp_file_size: 1024,

    pop3_use: 0,
    pop3_cache: 1,
    pop3_action: 0,
    pop3_file_size: 1024,

    ftp_use: 0,
    ftp_cache: 1,
    ftp_action: 0,
    ftp_file_size: 1024,

    imap_use: 0,
    imap_cache: 1,
    imap_action: 0,
    imap_file_size: 1024,

    hrst_file_type_use: 0,
    hrst_file_type_score: 50,
    hrst_http_rsps_use: 0,
    hrst_http_rsps_score: 50,
    hrst_irc_prtc_over_http_use: 0,
    hrst_irc_prtc_over_http_score: 50,
    hrst_action: 0
  }
})

export const mutations = {}

export const actions = {
  // APT 프로파일 조회
  async getAptProfileList ({commit, state}) {
    const res = await this.$axios.$get(
      `${state.api.url}`,
      state.api.config
    )
    return res
  },
  async getProfile ({commit, state}, profId = null) {
    const url = `${state.api.url}${(_.isNil(profId)) ? '' : `/${profId}`}`

    const res = await this.$axios.$get(
      url,
      state.api.config
    )
    return res
  },
  // APT 프로파일 추가/수정
  async setProfile ({commit, state}, [items, profId = null]) {
    const
      isAdd = _.isNil(profId),
      method = (isAdd) ? '$post' : '$put',
      url = `${state.api.url}${(isAdd) ? '' : `/${profId}`}`

    const res = await this.$axios[method](
      url,
      items,
      state.api.config
    )
    return res
  },
  // APT 프로파일 삭제
  async delProfile ({commit, state}, item) {
    const res = await this.$axios.$delete(
      `${state.api.url}`,
      _.assignIn(state.api.config, { data: item
      })
    )
    return res
  },
  // APT 프로파일 적용/취소
  async finalCommand ({commit, state}, {type, loadingShow = false}) {
    if (!_.includes(['apply', 'cancel'], type)) return 'nok'
    try {
      const param = _.assign({ loadingShow: loadingShow }, (_.eq(type, 'apply')) ? { applyMsg: true } : { cancelMsg: true })
      const {code, result} = await this.$axios.$put(`${state.finalCommand}/${type}`, null, param)
      if (code !== 'ok') {
        return result.msg
      }
      // this.dispatch(`common/common/setIsChanged`, false)
      return code
    } catch (e) {
      this.$log('[APT] finalCommand Exception -> ', e)

      return e
    }
  }
}

export const getters = {}

export const strict = false
